// A module store, not a Redux slice: the root CLAUDE.md keeps plain Redux to notifications and theme.
let preReleaseA = false;
const listeners = new Set<() => void>();

export const isPreReleaseA = (): boolean => preReleaseA;

export const markPreReleaseA = () => {
  if (preReleaseA) {
    return;
  }
  preReleaseA = true;
  listeners.forEach((listener) => listener());
};

export const resetReleaseMode = () => {
  preReleaseA = false;
  listeners.forEach((listener) => listener());
};

export const subscribeReleaseMode = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
